import productionSteamJacuzzi from "../abis/production/pools/steamJacuzzi";

const host = "https://bscscan.com/address";

export default [
  {
    title: "Steam Jacuzzi",
    contractAddress: "0x5003aec21592064d64a8edd0f33fe7eebda7c5d3",
    minApr: 3000,
    abi: productionSteamJacuzzi.abi,
    url: `${host}/0x5003aec21592064d64a8edd0f33fe7eebda7c5d3`,
  },
];
